import { create } from 'zustand';

const STORAGE_PREFIX = 'wf-active-location:';

// Sentinel meaning "all locations" (no filter applied).
export const ALL_LOCATIONS = 'all';

interface LocationState {
  activeLocationId: string;
  setActiveLocationId: (userId: string, workspaceId: string, locationId: string) => void;
  loadForContext: (userId: string, workspaceId: string) => void;
  reset: () => void;
}

// Persisted per-user AND per-workspace, mirroring stores/workspace.ts, since a
// member's chosen location only makes sense within a given workspace.
export const useLocationStore = create<LocationState>()((set) => ({
  activeLocationId: ALL_LOCATIONS,
  setActiveLocationId: (userId, workspaceId, locationId) => {
    localStorage.setItem(`${STORAGE_PREFIX}${userId}:${workspaceId}`, locationId);
    set({ activeLocationId: locationId });
  },
  loadForContext: (userId, workspaceId) => {
    set({ activeLocationId: localStorage.getItem(`${STORAGE_PREFIX}${userId}:${workspaceId}`) ?? ALL_LOCATIONS });
  },
  reset: () => {
    set({ activeLocationId: ALL_LOCATIONS });
  },
}));
